module.exports = __webpack_public_path__ + "static/media/discoverImg2.23f64ea9.jpg";